import "./SingleProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleProductTemplateSection from "./sections/SingleProductTemplateSection"
import TheStrideFooter from "@/reusable_sections/Footer"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <Header />
      <SingleProductTemplateSection />
      <TheStrideFooter />
    </div>
  )
}
